var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/core-js/modules/_shared-key.js
// module id = ../../../../core-js/modules/_shared-key.js
// module chunks = 0